import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
import { CloudService } from '../cloud.service';
import { AuthService } from 'app/auth/auth.service';
import Swal from 'sweetalert2';
import { BehaviorSubject, Observable } from 'rxjs';

// idiomas
import { lang_fileman } from 'app/idiomas/i18n/fileMan/filemanager.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import * as catalogo from './catalogo';
import { carpetasInicialesBetter, carpetasInicialesAll } from './catalogo';

const moment = require('moment');

@Component({
  selector: 'tablaArchivos',
  templateUrl: './tabla.component.html',
  styleUrls: ['./tabla.component.scss'],
  animations   : fuseAnimations
})
export class TablaComponent implements OnInit {

  listaArchivosEmpresa: backInter.getArchivosEmpresa;

  private eventsSubscription: any
  @Input() actualizaArchivos: Observable<any>;
  @Input() datosEmpresa: any;

  @Output() enviaIdCarpeta: EventEmitter<string> = new EventEmitter();
  @Output() direccionActual: EventEmitter<string> = new EventEmitter();
  @Output() archivoNuevo: EventEmitter<any> = new EventEmitter();
  @Output() tipoCloudNuevo: EventEmitter<any> = new EventEmitter();
  @Output() statusRaiz: EventEmitter<any> = new EventEmitter();

  nombresColumnas = ['icono','nombre', 'Extensión', 'Fecha de carga', 'tamaño', 'Descarga'];

  idiomaActual:string;

  puedeBorrar = true;
  enRaiz = true;
  idRaiz: string;

  carpetaActual = '';
  idCarpetaActual: string;
  datosCarpetaActual: any;
  nombreEmpresa: string;
  direccionRaiz = "./4fa42aa0ba652605cada43bca0fc6389/";

  htp:string;
  urlServidor:string;
  urlFileManager:string;
  idInstituto:string;
  urlFileServer:string;

  listaArchivos: any;
  listaArchivosTemp: any;

  historial = [];
  carpetasIniciales = catalogo.carpetasIniciales;
  boolsCarpInic = [false, false, false];

  carpetaEmpresa: any;
  idsProductos: any[] = [];

  //carpetasInicialesBetter = catalogo.carpetasInicialesBetter;
  boolsCarpInicBetter = [false, false, false];
  boolsCarpInicAll= [false];
  carpetasInicialesMX = catalogo.carpetasInicialesMX;
  carpetasInicialesAll = catalogo.carpetasInicialesAll;
  carpetasInicialesPriv = catalogo.carpetasInicialesPriv;
  boolsCarpInicPriv= [false];
  boolsCarpInicMX = [false, false, false, false, false];
  archivosInicialesMX = catalogo.archivosInicialesMX;
  archivosInicialesBetter = catalogo.archivosInicialesBetter;
  archivosInicialesPublic = catalogo.archivosInicialesPublic;

  /// VARIABLES NUEVOS SERVICIOS
  folderIdActual: string;
  listaSubcarpetasActual: any;
  cargandoArchivos: boolean;
  versionCloudNueva: boolean;
  fechaNuevaVersion = "2021-09-28";
  botonExcelTI: boolean;
  urlExcelTI: string;

  constructor(
    private translateSrv: TranslateService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private cloudService: CloudService,
    private wizardService: WizardService,
    private authService:AuthService,
    private activatedRoute : ActivatedRoute,
  ) {
    lang_fileman.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    // this.idInstituto = this.authService.getInstituto();
    // console.log("instituto: ", this.idInstituto);


    this.translateSrv.onLangChange.subscribe(() => { this.idiomaActual = this.translateSrv.currentLang; });
    let url = DATOS_API.urlLogos.split(":");
    let htp = DATOS_API.urlLogos.split("/");
    this.htp = htp[0];
    this.urlServidor = url[1];
    this.urlFileManager = DATOS_API.urlFileManager;
    this.urlFileServer = DATOS_API.endpoints.cloud.getArchivo;
    console.log("URL SERVIDOR" + this.urlServidor);

    this.activatedRoute.params.subscribe(params => {
      // console.log(params);
      if(params.version){
        console.log("parametro version de landing:",params.version);

        switch (params.version) {
          case 'legacy':
            this.fechaNuevaVersion = "2099-12-31";
          break;
          case 'current':
            this.fechaNuevaVersion = "1999-12-31";
          break;
        }
      }
    });
  }

  ngOnInit() {
    this.idiomaActual = this.translateSrv.currentLang;
    this.eventsSubscription = this.actualizaArchivos.subscribe( (datos) => {
      this.actualizarLista();
    });
    this.getProductsByCompany(this.datosEmpresa.idEmpresa);
    localStorage.setItem('BACK_PORTAL','Activo');
    // this.decodeUrl();
  }

  getProductsByCompany(idEmpresa:string) {
    this.cloudService.getProductosEmpresa(idEmpresa).subscribe((respuesta:backInter.infoProductos) => {
      console.log(respuesta);
      let arregloIDS:any[] = [];
      respuesta.productosCertificar.forEach(producto => {
        let datos:any = {
          id: producto.idCertificar,
          fecha: producto.fechaCertificar,
          nombre: `CONSULTATABLA.PRODUCTOS.${producto.idProducto}`,
          token: producto.tokenConfig
        };
        arregloIDS.push(datos);
      });
      respuesta.productosCultureAudit.forEach(producto => {
        let datos:any = {
          id: producto.idCulture,
          fecha: producto.fechaCulture,
          nombre: 'CONSULTATABLA.PRODUCTOS.8'
        };
        arregloIDS.push(datos);
      });
      respuesta.productosCultureAuditTR.forEach(producto => {
        let datos:any = {
          id: producto.idCulture,
          fecha: producto.fechaCulture,
          nombre: 'CONSULTATABLA.PRODUCTOS.10'
        };
        arregloIDS.push(datos);
      });
      respuesta.productosCultureAuditV2.forEach(producto => {
        let datos:any = {
          id: producto.idCulture,
          fecha: producto.fechaCulture,
          nombre: 'CONSULTATABLA.PRODUCTOS.9'
        };
        arregloIDS.push(datos);
      });
      respuesta.productosDocumentador.forEach(producto => {
        let datos:any = {
          id: producto.idDocumentador,
          fecha: producto.fechaDocumentador,
          nombre: 'CONSULTATABLA.PRODUCTOS.5'
        };
        arregloIDS.push(datos);
      });
      respuesta.productosFocusArea.forEach(producto => {
        let datos:any = {
          id: producto.idFocusArea,
          fecha: producto.fechaFocus,
          nombre: 'CONSULTATABLA.PRODUCTOS.6'
        };
        arregloIDS.push(datos);
      });
      respuesta.productosMedir.forEach(producto => {
        let datos:any = {
          id: producto.idMedir,
          fecha: producto.fechaMedir,
          nombre: 'CONSULTATABLA.PRODUCTOS.2'
        };
        arregloIDS.push(datos);
      });
      respuesta.productosMedir2.forEach(producto => {
        let datos:any = {
          id: producto.idProducto,
          fecha: producto.fechaProducto
        };
        switch (producto.tipo) {
          case 1: datos.nombre = 'CONSULTATABLA.PRODUCTOS.11'; break;
          case 2: datos.nombre = 'CONSULTATABLA.PRODUCTOS.12'; break;
          case 3: datos.nombre = 'CONSULTATABLA.PRODUCTOS.13'; break;
          case 4: datos.nombre = 'CONSULTATABLA.PRODUCTOS.14'; break;
          case 5: datos.nombre = 'CONSULTATABLA.PRODUCTOS.15'; break;
          case 6: datos.nombre = 'CONSULTATABLA.PRODUCTOS.16'; break;
        }
        arregloIDS.push(datos);
      });
      respuesta.productosNorma35.forEach(producto => {
        let datos:any = {
          id: producto.idNorma35,
          fecha: producto.fechaNorma35
        };
        switch (producto.tipo) {
          case 1: datos.nombre = 'CONSULTATABLA.PRODUCTOS.3'; break;
          case 2: datos.nombre = 'CONSULTATABLA.PRODUCTOS.19'; break;
        }
        arregloIDS.push(datos);
      });
      respuesta.productosPulseCheck.forEach(producto => {
        let datos:any = {
          id: producto.idPulseCheck,
          fecha: producto.fechaPulseCheck,
          nombre: 'CONSULTATABLA.PRODUCTOS.4'
        };
        arregloIDS.push(datos);
      });
      respuesta.productosResultados.forEach(producto => {
        let datos:any = {
          id: producto._id,
          fecha: producto.fecha,
          nombre: 'CONSULTATABLA.PRODUCTOS.17'
        };
        arregloIDS.push(datos);
      });
      respuesta.productosResultados4all.forEach(producto => {
        let datos:any = {
          id: producto._id,
          fecha: producto.fecha,
          nombre: 'CONSULTATABLA.PRODUCTOS.18'
        };
        arregloIDS.push(datos);
      });
      this.idsProductos = arregloIDS;
      console.log("arregloIDS:",arregloIDS);
      //obtiene nombre empresa
      // this.wizardService.getInfoEmpresa(this.datosEmpresa.idEmpresa).subscribe((data:backInter.infoEmpresa) => {
      //   this.nombreEmpresa = data.data.nombreEmpresa;
      //   this.gotoRaiz(true);
      // });
      this.revisionVersionCloud();
    }, error => {
      console.log("error", error);
    })
  }

  /////SERVICIOS NUEVOS
  revisionVersionCloud(){
    this.cloudService.getInfoEmpresa(this.datosEmpresa.idEmpresa).subscribe((respuesta:any) => {
      if(respuesta.message == 'Success'){
        this.nombreEmpresa = respuesta.data.nombreEmpresa;
        //REVISAR FECHA DE CREACION DE LA EMPRESA
        if(moment(respuesta.createdAt).isAfter(moment(this.fechaNuevaVersion)) ){  //si la fecha es posterior a la indicada, nueva version
          this.versionCloudNueva = true;
          this.tipoCloudNuevo.emit(true);
          // this.nuevo_gotoRaiz(true);
          this.nuevo_gotoRaiz(false);
        } else{   //version anterior
          this.gotoRaiz(true);
        }
      }
    });
  }
  async nuevo_gotoRaiz(entrarCarpeta?:boolean){
    this.idCarpetaActual = null;
    this.datosCarpetaActual = null;
    this.direccionRaiz = this.datosEmpresa.idEmpresa;
    this.historial = [];
    this.enviaDireccionActual();
    this.enviaIdCarpetaActual(null);
    this.statusRaiz.emit(true);

    // this.cloudService.getArchivos_nuevo("").subscribe((respuesta:any) => {
      const respuesta:any = await this.cloudService.getArchivos_nuevo("").toPromise();
      console.log("getArchivos_nuevo raiz:",respuesta);
      if(respuesta.success){
        this.nuevo_getCarpeta(null, null, true, entrarCarpeta);
      } else{
        this.nuevo_creaCarpetaRaiz();
      }
    // });
  }
  nuevo_creaCarpetaRaiz(){
    const datos = {
      empresaId: this.datosEmpresa.idEmpresa,
      folderId: null,
      path: this.datosEmpresa.idEmpresa,
      itbm: true
    };
    this.cloudService.creaCarpeta_nuevo(datos).subscribe((respuesta:any) => {
      console.log("creaCarpeta_nuevo:",respuesta);
      // this.nuevo_gotoRaiz(true);
      this.nuevo_gotoRaiz(false);
    })
  }
  nuevo_getCarpeta_back(datosFolder?:any, subcarpetas?:boolean, raiz?: boolean, entrarCarpeta?:boolean){
    console.log("entró nuevo get carpeta, datos:", {
      datosFolder,
      subcarpetas,
      raiz,
      entrarCarpeta
    });

    // if(this.idCarpetaActual != datosFolder._id){
      this.listaArchivos = [];
      this.cargandoArchivos = true;
      let folderId: string = null;
      if(datosFolder){
        this.datosCarpetaActual = datosFolder;
        folderId = datosFolder._id;
      }
      console.log("folderId a buscar:",folderId);

      this.cloudService.getCarpetas_nuevo(folderId).subscribe((respuesta_2:any) => {
        console.log("getCarpetas_nuevo:",respuesta_2);
        if(respuesta_2.success){
          if(!subcarpetas){ /// PRIMER PASO, OBTENCION DE DATOS DE LA CARPETA
            this.listaArchivosTemp = [];
            this.enRaiz = false;
            if(raiz){
              this.datosCarpetaActual = respuesta_2.folders[0];
              this.enRaiz = true;
            }
            this.idCarpetaActual = this.datosCarpetaActual._id;
            console.log("datosCarpetaActual:",this.datosCarpetaActual);
            this.direccionRaiz = this.datosCarpetaActual.path;
            this.enviaDireccionActual();
            //hacer el get de nuevo para obtener las subcarpetas
            // this.nuevo_getCarpeta(this.datosCarpetaActual, true, null, entrarCarpeta);
            if(this.datosCarpetaActual.folderId){
              this.depuraHistorial(datosFolder);
            }
          } else{ /// SEGUNDO PASO, OBTENCION DE LISTA DE SUBCARPETAS Y ARCHIVOS
            this.listaSubcarpetasActual = respuesta_2.folders;
            // console.log("subcarpetas de la actual:",this.listaSubcarpetasActual);
            this.listaSubcarpetasActual.forEach(subcarpeta => {
              subcarpeta.tipoArchivo = 'folder';
              const nombreSubCarp = subcarpeta.path.split('/');
              subcarpeta.nombre = nombreSubCarp[nombreSubCarp.length - 1];
              if(this.datosCarpetaActual.folderId == null){
                if(subcarpeta.itbm){
                  this.listaArchivosTemp.push(subcarpeta);
                }
              } else{
                this.listaArchivosTemp.push(subcarpeta);
              }
            });
            console.log("listaArchivosTemp:",this.listaArchivosTemp);
            //revisa subcarpetas de productos agregados
            if(this.datosCarpetaActual.folderId == null){
              this.nuevo_revisaSubcarpetaProducto(entrarCarpeta);
            }
            if(this.datosCarpetaActual.itbm && this.datosCarpetaActual.fechaProducto != undefined){  //si es carpeta itbm y es una carpeta de producto
              console.log("entrará a carpetas detault privadas");
              console.log("datosCarpetaActual:",JSON.parse(JSON.stringify(this.datosCarpetaActual)));

              this.nuevo_carpetasDefaultPrivadas();
            }

            //hace el get de los archivos
            if(this.datosCarpetaActual.folderId != null){   //solo hace el get de archivos si no es la raiz
              this.nuevo_getArchivos(this.datosCarpetaActual.path);
            } else{ //si es la raiz, finaliza la carga
              this.listaArchivos = this.listaArchivosTemp;
              this.cargandoArchivos = false;
              this.registroVacio();
              console.log("listaArchivos:",this.listaArchivos);
            }
          }
        }
      });
    // }
  }
  async nuevo_getCarpeta(datosFolder?:any, subcarpetas?:boolean, raiz?: boolean, entrarCarpeta?:boolean){
    // console.log("datosFolder:",datosFolder);
    ///CONSULTA SI LA CARPETA TIENE ARCHIVOS EXCEL TI
    if(datosFolder != null){
      if(datosFolder.token != undefined){
        const consultaExcelTI: any = await this.cloudService.getExcelTI({surveyToken:datosFolder.token}).toPromise();
        console.log("consultaExcelTI:", consultaExcelTI);
        this.botonExcelTI = consultaExcelTI.success;
        this.urlExcelTI = consultaExcelTI.success == true ? consultaExcelTI.urlZip : undefined;
      } else this.botonExcelTI = false;
    } else this.botonExcelTI = false;
    await this.nuevo_getCarpeta_paso1(datosFolder, subcarpetas, raiz);
    console.log("datosCarpetaActual:",this.datosCarpetaActual);
    await this.nuevo_getCarpeta_paso2(this.datosCarpetaActual._id, entrarCarpeta);
    console.log("EN RAIZ:",this.enRaiz);

  }

  async nuevo_getCarpeta_paso1(datosFolder?:any, subcarpetas?:boolean, raiz?: boolean){
    this.listaArchivos = [];
    this.cargandoArchivos = true;
    let folderId: string = null;
    if(datosFolder){
      this.datosCarpetaActual = datosFolder;
      folderId = datosFolder._id;
    }
    let respuesta_2:any = await this.cloudService.getCarpetas_nuevo(folderId).toPromise();
    console.log("getCarpetas_nuevo_paso1:",respuesta_2);
    if(respuesta_2.success){
      this.listaArchivosTemp = [];
      this.enRaiz = false;
      if(raiz){
        this.datosCarpetaActual = respuesta_2.folders[0];
        this.enRaiz = true;
        this.idRaiz = respuesta_2.folders[0]._id;
        this.statusRaiz.emit(true);
      }
      else{
        this.statusRaiz.emit(false);
      }
      this.idCarpetaActual = this.datosCarpetaActual._id;
      this.direccionRaiz = this.datosCarpetaActual.path;
      this.enviaDireccionActual();
      if(this.datosCarpetaActual.folderId){
        this.depuraHistorial(datosFolder);
      }
    }
  }
  async nuevo_getCarpeta_paso2(folderId:string, entrarCarpeta?:boolean){
    let respuesta_2: any = await this.cloudService.getCarpetas_nuevo(folderId).toPromise();
    console.log("getCarpetas_nuevo_paso2:",respuesta_2);
    if(respuesta_2.success){
      this.listaSubcarpetasActual = respuesta_2.folders;
      // console.log("subcarpetas de la actual:",this.listaSubcarpetasActual);
      this.listaSubcarpetasActual.forEach(subcarpeta => {
        subcarpeta.tipoArchivo = 'folder';
        const nombreSubCarp = subcarpeta.path.split('/');
        subcarpeta.nombre = nombreSubCarp[nombreSubCarp.length - 1];
        if(this.datosCarpetaActual.folderId == null){
          if(subcarpeta.itbm){
            this.listaArchivosTemp.push(subcarpeta);
          }
        } else{
          this.listaArchivosTemp.push(subcarpeta);
        }
      });
      console.log("listaArchivosTemp:",this.listaArchivosTemp);
      //revisa subcarpetas de productos agregados
      if(this.datosCarpetaActual.folderId == null){
        this.nuevo_revisaSubcarpetaProducto(entrarCarpeta);
        this.listaArchivos = this.listaArchivosTemp;
        this.cargandoArchivos = false;
        this.registroVacio();
        console.log("listaArchivos:",this.listaArchivos);
        return;
      }
      if(this.datosCarpetaActual.itbm == true && this.datosCarpetaActual.fechaProducto != undefined){  //si es carpeta itbm y es una carpeta de producto
        this.nuevo_carpetasDefaultPrivadas();
      }

      //hace el get de los archivos
      if(this.datosCarpetaActual.folderId != null){   //solo hace el get de archivos si no es la raiz
      // console.log("K PEDO VA AENTRAR O KE CHOW");

        this.nuevo_getArchivos(this.datosCarpetaActual.path);
      }
    }
  }
  nuevo_getArchivos(ruta:string){
    const idEmpresa = localStorage.getItem('companyID');
    ruta = ruta.replace(new RegExp(idEmpresa,"g"),'');
    // console.log("ENTRO GET ARCHIVOS, RUTA:",ruta);

    this.cloudService.getArchivos_nuevo(ruta).subscribe((respuesta:any) => {
      console.log("getArchivos_nuevo:",respuesta);
      if(respuesta.success){
        respuesta.records.forEach(registro => {
          if(registro.Type == 'File'){
            let nombreExt = registro.Path.split('.');
            this.listaArchivosTemp.push({
                carpetaId: this.datosCarpetaActual._id,
                vivo: 1,
                _id: "ID_DEL_ARCHIVO",
                nombre: registro.Path,
                nombreArchivoCode: this.encode(registro.Path),
                ubicacion: this.encode(this.datosCarpetaActual.path),
                tamanio: registro.Size,
                tipo: nombreExt[nombreExt.length - 1],
                createdAt: registro.LastModified,
                itbm: true
            });
          }
        });
        this.listaArchivos = this.listaArchivosTemp;
        this.cargandoArchivos = false;
        // this.nuevo_revisaArchivosDefault_paso1();
        this.registroVacio();
        console.log("listaArchivos:",this.listaArchivos);
      }
    });
  }

  nuevo_revisaSubcarpetaProducto(entrarCarpeta?:boolean){
    this.listaArchivosTemp.forEach(carpeta => {
      if(carpeta.itbm){
        let indice = this.idsProductos.findIndex(item => item.id === carpeta.nombre);
        if(indice != -1){
          carpeta.nombreProducto = this.idsProductos[indice].nombre;
          carpeta.fechaProducto = this.idsProductos[indice].fecha;
          carpeta.token = this.idsProductos[indice].token != undefined ? this.idsProductos[indice].token : undefined;
        }
        if(!entrarCarpeta){
          this.listaArchivos.push(carpeta);
        }
        if(carpeta.nombre == this.datosEmpresa.idProducto){
          this.carpetaEmpresa = carpeta;
        }
      }
    });
    if(entrarCarpeta){
      this.carpetaProducto();
    }
  }
  nuevo_creaCarpetaDef(nomCarpeta: any, interna?: boolean, indice?: number){
    console.log("entró creaCarpetaDef nuevo");

    const datos = {
      empresaId: this.datosEmpresa.idEmpresa,
      folderId: this.datosCarpetaActual._id,
      path: this.datosCarpetaActual.path + '/' + nomCarpeta,
      itbm: true
    };
    console.log("datos carpeta def nueva:",datos);


    this.cloudService.creaCarpeta_nuevo(datos).subscribe((respuesta:any) => {
      if(respuesta.success){
        if(interna){
          this.actualizarLista();
          this.boolsCarpInicPriv[indice] = true;
        }
        else{
          // this.gotoRaiz(true);
          // this.nuevo_gotoRaiz(true);
          this.nuevo_gotoRaiz(false);
        }
      }
    });
  }
  nuevo_carpetasDefaultPrivadas(){
    this.listaArchivosTemp.forEach(carpetaActual => {
      this.carpetasInicialesPriv.forEach((carpetaPriv, i) => {
        if(carpetaActual.nombre == carpetaPriv.carpeta){
          this.boolsCarpInicPriv[i] = true;
        }
      });
    });

    this.carpetasInicialesPriv.forEach((carpetaPriv,i) => {
      if(!this.boolsCarpInicPriv[i]){
        this.nuevo_creaCarpetaDef(carpetaPriv.carpeta,true,i);
      }
    });
  }
  nuevo_guardaCarpeta(){
    let texto = this.translateSrv.instant('FILEMANAGER.MENSAJES.CREATEFOLDER');
    let rspSi = this.translateSrv.instant('FILEMANAGER.MENSAJES.BOTONES.CREAR');
    let rspNo = this.translateSrv.instant('FILEMANAGER.MENSAJES.BOTONES.CANCELAR');
    Swal.fire({
      title: texto,
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
reverseButtons: true,
      confirmButtonText: rspSi,
      cancelButtonText: rspNo,
      showLoaderOnConfirm: true,

      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.value) {
        const datos = {
          empresaId: localStorage.getItem('companyID'),
          folderId: this.datosCarpetaActual._id,
          path: this.datosCarpetaActual.path + '/' + result.value,
          itbm: true
        };

        this.cloudService.creaCarpeta_nuevo(datos).subscribe((respuesta:any) => {
          console.log("creaCarpeta_nuevo:",respuesta);
          if(respuesta.success){
            this.mensajeSwal('FILEMANAGER.MENSAJES.FOLDEROK',1);
            this.actualizarLista();
          } else{
            this.mensajeSwal('FILEMANAGER.MENSAJES.'+respuesta.message,3);
          }
        });
      }
    });
  }

  nuevo_borraArchivo(ubicacion:string, opcion:number){
    let texto:string;
    switch (opcion) {
      case 1: texto = this.translateSrv.instant('FILEMANAGER.MENSAJES.DELETERLY'); break;
      case 2: texto = this.translateSrv.instant('FILEMANAGER.MENSAJES.DELETEFOLDERRLY'); break;
    }
    let rspSi = this.translateSrv.instant('FILEMANAGER.MENSAJES.BOTONES.SI');
    let rspNo = this.translateSrv.instant('FILEMANAGER.MENSAJES.BOTONES.NO');

    Swal.fire({
      title: texto,
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,


      confirmButtonText: rspSi,
      cancelButtonText: rspNo
    }).then((result) => {
      if (result.value) {
        switch (opcion) {
          case 1: //archivo
            this.cloudService.borraArchivo_nuevo(decodeURIComponent(ubicacion)).subscribe( (data:any) => {
              console.log("borraArchivo_nuevo:",data);
              if(data.success){
                this.mensajeSwal('FILEMANAGER.MENSAJES.DELETEOK',1);
                this.actualizarLista();
              }
            });
          break;
          // case 2: //carpeta
          //   this.cloudService.borraCarpeta(idArchivo).subscribe( (data:backInter.RespuestaGen) => {
          //   if(data.success){
          //       this.mensajeSwal('FILEMANAGER.MENSAJES.DELETEFOLDEROK',1);
          //       this.actualizarLista();
          //     }
          //     console.log(data);
          //   });
          // break;
        }
      }
    });
  }

  /////SERVICIOS NUEVOS

  enviaDireccionActual(){
    this.direccionActual.emit(this.direccionRaiz);
  }
  enviaIdCarpetaActual(idCarpeta:string){
    this.enviaIdCarpeta.emit(idCarpeta);
  }

  gotoRaiz(entrarCarpeta?:boolean){
    this.idCarpetaActual = null;
    this.datosCarpetaActual = null;
    this.direccionRaiz = this.direccionRaiz + this.datosEmpresa.idEmpresa + "/";
    this.historial = [];
    this.enviaDireccionActual();
    this.enviaIdCarpetaActual(null);
    this.getRaiz(entrarCarpeta);
    this.enRaiz = true;
    this.statusRaiz.emit(true);
  }

  getRaiz(entrarCarpeta?:boolean){
    this.cloudService.getCarpetaRaiz(this.datosEmpresa.idEmpresa).subscribe( (data:backInter.getCarpetaRaiz) => {

      //Busca la carpeta del producto seleccionado, si no existe la crea
      let carpetasSinFiltro = data.carpetas;
      this.listaArchivos = [];
      carpetasSinFiltro.forEach((carpeta:any) => {
        if(carpeta.itbm){
          carpeta.tipoArchivo = 'folder';
          let indice = this.idsProductos.findIndex(item => item.id === carpeta.nombre);
          if(indice != -1){
            carpeta.nombreProducto = this.idsProductos[indice].nombre;
            carpeta.fechaProducto = this.idsProductos[indice].fecha;
          }
          if(!entrarCarpeta){
            this.listaArchivos.push(carpeta);
          }
          if(carpeta.nombre == this.datosEmpresa.idProducto){
            this.carpetaEmpresa = carpeta;
          }
        }
      });
      console.log(this.listaArchivos);

      if(entrarCarpeta){
        this.carpetaProducto();
      }
    });
  }

  depuraHistorial(datosCarpeta:any){
    let nuevoHistorial: any[] = [];
    var BreakException = {};
    try {
      this.historial.forEach(carpeta => {
        // if(carpeta._id != datosCarpeta._id && datosCarpeta._id != this.carpetaEmpresa._id){
        if(carpeta._id != datosCarpeta._id){
          nuevoHistorial.push(carpeta);
        }
        else throw BreakException;
      });
    } catch (e) {
      if (e !== BreakException) throw e;
    };
    this.historial = nuevoHistorial;
    // if(datosCarpeta._id != this.carpetaEmpresa._id){
      this.historial.push(datosCarpeta);
    // }
  }

  registroVacio(){
    if(this.listaArchivos.length == 0){
      this.listaArchivos.push({tipoArchivo: 'vacio'});
    }
  }

  archivosDefaultPriv(nombreCarpeta:string){
    // let indice = this.carpetasInicialesMX.indexOf(nombreCarpeta);
    let listaArchivos: any;
    var BreakException = {};
    try {
      this.archivosInicialesPublic.forEach(element => {
          let arrArchivos = this.archivosSubcarpetaDefault(nombreCarpeta, element, DATOS_API.urlAssets + 'cloud_mx');
          if(arrArchivos.encontrado){
            listaArchivos = arrArchivos;
            // console.log("Lista archivos:",listaArchivos);
            throw BreakException;
          }
      });
    } catch (e) {
      if (e !== BreakException) throw e;
    };
    if(listaArchivos){
      if(listaArchivos.archivos){
        listaArchivos.archivos.forEach((nomFile:any,i) => {
          let archivo = {
            nombre: nomFile.nombre,
            ubicacion: listaArchivos.rutaCompleta + "/",
            tamanio: nomFile.tamanio,
            archivoDef: true,
            nombreArchivoCode: nomFile.nombre,
          }
          this.listaArchivos.push(archivo);
          console.log('this.listaArchivos*******************',this.listaArchivos);

        });
      }
    }
  }

  archivosSubcarpetaDefault(nombreCarp: string, carpetaActual: any, ruta: string){

    let archivos: any;
    let encontrado: boolean;
    let rutaCompleta = ruta;
    if(carpetaActual.carpeta == nombreCarp){
      archivos = carpetaActual.archivos;
      encontrado = true;
      rutaCompleta = rutaCompleta + "/" + carpetaActual.carpeta;
      // console.log("ruta final via 1: ",rutaCompleta);
    }
    else{
      if(carpetaActual.subcarpeta){
        if(carpetaActual.subcarpeta.length > 0){
          var BreakException = {};
          try {
            rutaCompleta = rutaCompleta + "/" + carpetaActual.carpeta;
            carpetaActual.subcarpeta.forEach((carpetaMx, i) => {
              let datosSub = this.archivosSubcarpetaDefault(nombreCarp,carpetaMx,rutaCompleta);
              if(datosSub.encontrado){
                archivos = datosSub.archivos;
                encontrado = datosSub.encontrado;
                rutaCompleta = datosSub.rutaCompleta;
                // console.log("ruta final via2: ",rutaCompleta);
                throw BreakException;
              }
            });
          } catch (e) {
            if (e !== BreakException) throw e;
          };
        }
      }
    }
    // console.log("resutlados archivosSubcarpetaDefault: ",archivos,encontrado,rutaCompleta);
    return {encontrado,archivos,rutaCompleta};
  }

  carpetaProducto(){
    console.log("carpetaProducto:",this.carpetaEmpresa);
    console.log("vacia?:",this.carpetaEmpresa === undefined);
    if(this.carpetaEmpresa === undefined){
      console.log("carpeta empresa vacia, se creará default");

      this.versionCloudNueva == true ? this.nuevo_creaCarpetaDef(this.datosEmpresa.idProducto) : this.creaCarpetaDef(this.datosEmpresa.idProducto);
    }
    else{
      console.log("carpeta empresa existe, se hará get");

      this.versionCloudNueva == true ? this.nuevo_getCarpeta(this.carpetaEmpresa) : this.getCarpeta(this.carpetaEmpresa);
    }
  }

  creaCarpetaDef(nomCarpeta: string, interna?: boolean, indice?: number){
    console.log("creara default");
    let datos:any = {
      nombre: nomCarpeta,
      ubicacion: this.direccionRaiz,
    };
    if(!interna){
      datos.empresaId = this.datosEmpresa.idEmpresa;
      datos.itbm = true;
    }
    else{
      datos.carpetaId = this.idCarpetaActual;
    }
    this.cloudService.guardaCarpeta(datos).subscribe((respuesta:backInter.guardaCarpeta) => {
      if(respuesta.success){
        console.log("guardaDefault:",respuesta);
        if(interna){
          this.actualizarLista();
          this.boolsCarpInicPriv[indice] = true;
        }
        else{
          this.gotoRaiz(true);
        }
      }
    }, error => {
      console.log(error);
    });
  }

  carpetasDefaultPrivadas(){
    console.log("crearaPrivadas");
    this.listaArchivos.forEach(carpetaActual => {
      if(carpetaActual.tipoArchivo == 'folder'){

        this.carpetasInicialesPriv.forEach((carpetaPriv, i) => {
          if(carpetaActual.nombre == carpetaPriv.carpeta){
            this.boolsCarpInicPriv[i] = true;
          }
        });
      }
    });
    //console.log("boolsMx: ",this.boolsCarpInicMX);

    this.carpetasInicialesPriv.forEach((carpetaPriv,i) => {
      if(!this.boolsCarpInicPriv[i])
        this.creaCarpetaDef(carpetaPriv.carpeta,true,i);
    });
  }

  getCarpeta(datosCarpeta:any, actualiza?:boolean){
    // console.log(datosCarpeta);

    if(this.idCarpetaActual != datosCarpeta._id || actualiza){
      this.depuraHistorial(datosCarpeta);
      this.datosCarpetaActual = datosCarpeta;
      this.idCarpetaActual = datosCarpeta._id;
      this.direccionRaiz = this.direccionRaiz + datosCarpeta.nombre + "/";
      this.enviaDireccionActual();
      this.enviaIdCarpetaActual(datosCarpeta._id);
      this.cloudService.getCarpeta(datosCarpeta._id).subscribe( (data:any) => {
        console.log(data);
        this.listaArchivos = data.subcarpetas;
        this.listaArchivos.forEach(carpeta => {
          carpeta.tipoArchivo = 'folder';
        });

        data.archivos.forEach(archivo => {
          archivo.nombreArchivoCode= archivo.nombre;
          // archivo.nombre= this.encode(archivo.nombre);
          // archivo.ubicacion= this.encode(archivo.ubicacion);
          this.listaArchivos.push(archivo);
        });
        if(datosCarpeta.itbm){  //si es carpeta itbm
          this.carpetasDefaultPrivadas();
        }
        console.log(datosCarpeta);
        console.log(this.listaArchivos);

        // this.archivosDefaultPriv(datosCarpeta.nombre);
        this.registroVacio();
        this.enRaiz = false;
        this.statusRaiz.emit(false);
        this.cargandoArchivos = false;
      });
    }
  }

  guardaArchivoNuevo(evt: any){
    this.archivoNuevo.emit(evt);
  }

  guardaCarpeta(){
    let texto = 'FILEMANAGER.MENSAJES.CREATEFOLDER';
    let rspSi = 'FILEMANAGER.MENSAJES.BOTONES.CREAR';
    let rspNo = 'FILEMANAGER.MENSAJES.BOTONES.CANCELAR';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });
    Swal.fire({
      title: texto,
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
reverseButtons: true,
      confirmButtonText: rspSi,
      cancelButtonText: rspNo,
      showLoaderOnConfirm: true,

      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.value) {
        // console.log(result.value);

        let datos:any = {
          nombre: result.value,
          ubicacion: this.direccionRaiz
        };
        if(this.idCarpetaActual){
          datos.carpetaId = this.idCarpetaActual;  //solo cuando no es la raiz
        }
        console.log(datos);


        this.cloudService.guardaCarpeta(datos).subscribe((respuesta:backInter.guardaCarpeta) => {
          console.log(respuesta);
          if(respuesta.success){
            this.mensajeSwal('FILEMANAGER.MENSAJES.FOLDEROK',1);
            this.actualizarLista();
          }
          else{
            this.mensajeSwal('FILEMANAGER.MENSAJES.'+respuesta.message,3);
          }
        }, error => {
          console.log(error);
        });

      }
    });
  }

  actualizarLista(){
    console.log("DATOS ACTUALIZAR:",{
      idCarpetaActual: this.idCarpetaActual,
      versionCloudNueva: this.versionCloudNueva,
      datosCarpetaActual: this.datosCarpetaActual,
      idRaiz: this.idRaiz
    });

    if(!this.idCarpetaActual){
      this.versionCloudNueva == true ? this.nuevo_gotoRaiz() : this.getRaiz();
    }
    else{
      if(this.datosCarpetaActual._id == this.idRaiz){
        this.versionCloudNueva == true ? this.nuevo_gotoRaiz() : this.getRaiz();
      } else{
        this.versionCloudNueva == true ? this.nuevo_getCarpeta(this.datosCarpetaActual) : this.getCarpeta(this.datosCarpetaActual, true);
      }
    }
  }

  borraArchivo(idArchivo:string, opcion:number){
    let texto:string;
    switch (opcion) {
      case 1: texto = 'FILEMANAGER.MENSAJES.DELETERLY'; break;
      case 2: texto = 'FILEMANAGER.MENSAJES.DELETEFOLDERRLY'; break;
    }
    let rspSi = 'FILEMANAGER.MENSAJES.BOTONES.SI';
    let rspNo = 'FILEMANAGER.MENSAJES.BOTONES.NO';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });

    Swal.fire({
      title: texto,
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,


      confirmButtonText: rspSi,
      cancelButtonText: rspNo
    }).then((result) => {
      if (result.value) {
        switch (opcion) {
          case 1: //archivo
            this.cloudService.borraArchivo(idArchivo).subscribe( (data:backInter.RespuestaGen) => {
              if(data.success){
                this.mensajeSwal('FILEMANAGER.MENSAJES.DELETEOK',1);
                this.actualizarLista();
              }
              console.log(data);
            });
          break;
          case 2: //carpeta
            this.cloudService.borraCarpeta(idArchivo).subscribe( (data:backInter.RespuestaGen) => {
            if(data.success){
                this.mensajeSwal('FILEMANAGER.MENSAJES.DELETEFOLDEROK',1);
                this.actualizarLista();
              }
              console.log(data);
            });
          break;
        }
      }
    });


  }

  mensajeSwal(mensaje:string, tipoMsg:number){
    let texto = '';
    this.translateSrv.get(mensaje).subscribe((res: string) => { texto = res; });
    let tipo: any;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    switch(tipoMsg){
      case 1: tipo = 'success'; break;
      case 2: tipo = 'warning'; break;
      case 3: tipo = 'error'; break;
    }
    Swal.fire({
      title: texto,
      icon: tipo,
      confirmButtonText: rspSi,
      confirmButtonColor: '#e40601'
    });
  }

// decodeUrl(){
// let datos=encodeURIComponent('615c76c4c368491249095dd4/615e1bc8f319f34dec4e4863/Raw Data/Catalonia Hotels & Resorts_2021.xlsx');
// let datos2=decodeURIComponent('615c76c4c368491249095dd4/615e1bc8f319f34dec4e4863/Raw Data/Catalonia%20Hotels%20&%20Resorts_2021.pdf');
// console.log('encodeURIComponent',datos);
// console.log('decodeURIComponent',datos2);
//
// }
// url(ubica,name){
//   let path= ubica+'/'+name;
//   let datos=encodeURIComponent(path);
//   console.log('encodeURIComponent',datos);
//   console.log('name',name);
//   console.log('ubica',ubica);
//   console.log(this.urlFileServer+datos);
//   let urlCorrecta= this.urlFileServer+datos;
//   // document.getElementById('enlace').innerHTML ='<a href="'+urlCorrecta+'" target="_blank" download></a>';
//   document.getElementById('enlace').setAttribute('href', this.urlFileServer+datos);
//
// }

encode(content: string){
  console.log('content',content);
  return encodeURIComponent(content);
}


}
